<form [formGroup]="formUser">
  <div class="row">
    <div class="col-6">
      <div class="form-group mb-3">
        <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Nombre:" formControlName="first_name" i18n-placeholder />
        @if (formUser.get("first_name")?.invalid && formUser.get("first_name")?.touched) {
          <small>Is required.</small>
        }
      </div>

      <div class="form-group mb-3">
        <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Teléfono:" formControlName="phone" i18n-placeholder />
        @if (formUser.get("phone")?.invalid && formUser.get("phone")?.touched) {
          <small>Is required.</small>
        }
      </div>
    </div>
    <div class="col-6">
      <div class="form-group mb-3">
        <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Apellido" formControlName="last_name" i18n-placeholder />
        @if (formUser.get("last_name")?.invalid && formUser.get("last_name")?.touched) {
          <small>Is required.</small>
        }
      </div>
      <div class="form-group mb-3">
        <input type="mail" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Correo electrónico:" formControlName="email" i18n-placeholder />
        @if (formUser.get("email")?.invalid && formUser.get("email")?.touched) {
          <small>Is required.</small>
        }
      </div>
    </div>

    <div class="col-12">
      <div class="form-group mb-3">
        <select class="form-control" name="" id="" (change)="selectCountry($event.target)" formControlName="country" i18n-placeholder>
          <option value="">Selecciona un país:</option>
          @for (item of listCountries; track $index) {
            <option [value]="item.code">{{ item.name }}</option>
          }
        </select>
        @if (formUser.get("country")?.invalid && formUser.get("country")?.touched) {
          <small>Is required.</small>
        }
      </div>
      <div class="form-group mb-3">
        <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Calle:" formControlName="street" i18n-placeholder />
        @if (formUser.get("street")?.invalid && formUser.get("street")?.touched) {
          <small>Is required.</small>
        }
      </div>
      <div class="form-group mb-3">
        <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Numero:" formControlName="number" i18n-placeholder />
        @if (formUser.get("number")?.invalid && formUser.get("number")?.touched) {
          <small>Is required.</small>
        }
      </div>
    </div>

    <div class="col-6">
      <div class="form-group mb-3">
        <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Codigo Postal:" formControlName="postalCode" i18n-placeholder />
        @if (formUser.get("postalCode")?.invalid && formUser.get("postalCode")?.touched) {
          <small>Is required.</small>
        }
      </div>

      <div class="form-group mb-3">
        <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Ciudad:" formControlName="city" i18n-placeholder />
        @if (formUser.get("city")?.invalid && formUser.get("city")?.touched) {
          <small>Is required.</small>
        }
      </div>
    </div>
    <div class="col-6">
      @if (enableColonia) {
        <div class="form-group mb-3">
          <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Colonia:" formControlName="district" i18n-placeholder />
          @if (formUser.get("district")?.invalid && formUser.get("district")?.touched) {
            <small>Is required.</small>
          }
        </div>
      }

      <div class="form-group mb-3">
        <select class="form-control" name="" id="" formControlName="state" i18n-placeholder>
          <option value="">Selecciona el estado:</option>
          @for (item of listStates; track $index) {
            <option [value]="item.code_3_digits">{{ item.name }}</option>
          }
        </select>
        @if (formUser.get("state")?.invalid && formUser.get("state")?.touched) {
          <small>Is required.</small>
        }
      </div>
    </div>
  </div>

  <button (click)="calculateShipping()" class="btn btn__default btn__block" [disabled]="">Continuar</button>
</form>
